module.exports = __webpack_public_path__ + "static/img/tcbg.d72fb130.png";